"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var alphabetic = function alphabetic(key) {
  return function (itemA, itemB) {
    var a = itemA[key];
    var b = itemB[key];

    if (a === b) return 0;

    if (!a) return 1;
    if (!b) return -1;

    return a > b ? 1 : -1;
  };
};

exports.default = alphabetic;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/sorting/compareFns/alphabetic.js
// module id = 2280
// module chunks = 0